function clear_field(field_name) {
    var $field = $("[name='" + field_name + "']");
    if ($field.eq(0).is(':radio') || $field.eq(0).is(':checkbox')) {
        $field.prop('checked', false);
    } else {
        $field.val('');
    }
}

// WS uses a lot of '.' in slot name/ids.
// which breaks jquery selectors, this is
// straight from the jquery docs.
// http://learn.jquery.com/using-jquery-core/faq/how-do-i-select-an-element-by-an-id-that-has-characters-used-in-css-notation/

function jq_escape( myid ) {
    return "#" + myid.replace( /(:|\.|\[|\]|,)/g, "\\$1" );
}
